<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true">
    </loading>
    <v-app-bar absolute id="app-bar" color="#81C0E2" style="height: 64px" elevate-on-scroll scroll-target="#scrolling-techniques-7">
      <div class="d-inline-block" style="width:160px">
        <v-img :src="images.new_logo" width=280 alt="中華企業資源規劃學會LOGO"></v-img>
      </div>
    </v-app-bar>
    <v-row style="height:64px; width:100%">
    </v-row>
    <v-row class="ma-5 mb-0">
      <v-btn v-if="registerConsent === 1" class="ma-0 pa-0" outlined style="width:130px; height:40px; background:#FFF; border-radius:8px; border: 1px solid #969698" @click="redirectPath('/login')">
        <v-icon style="color:#969698">mdi-arrow-left-bold-circle-outline</v-icon>
        <span class="px-1" style="font-size:13pt; color:#969698">回登入頁</span>
      </v-btn>
      <v-btn v-if="registerConsent === 2" class="ma-0 pa-0" outlined style="width:130px; height:40px; background:#FFF; border-radius:8px; border: 1px solid #969698" @click="registerConsent = 1">
        <v-icon style="color:#969698">mdi-arrow-left-bold-circle-outline</v-icon>
        <span class="px-1" style="font-size:13pt; color:#969698">回註冊頁</span>
      </v-btn>
    </v-row>

    <v-stepper v-if="registerConsent === 1" :style="viewStyle1" style="overflow-x:hidden; overflow-y:scroll" v-model="e1">
      <v-stepper-header style="height: 80px; box-shadow:none">
        <v-row class="ma-0 mt-n2" justify="center">
          <v-col cols="8" class="pa-0">
            <v-row class="mt-3">
              <v-stepper-step color="#81C0E2" complete-icon="mdi-check" style="font-size:13pt; font-weight:700" :complete="e1 > 1" step="1">
                選擇身份
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step color="#81C0E2" complete-icon="mdi-check" style="font-size:13pt; font-weight:700" :complete="e1 > 2" step="2">
                帳號資訊
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step color="#81C0E2" style="font-size:13pt; font-weight:700" step="3">
                開通說明
              </v-stepper-step>
            </v-row>
          </v-col>
        </v-row>
      </v-stepper-header>

      <v-stepper-items>
        <!-- 選擇身份 -->
        <v-stepper-content step="1">
          <v-card class="my-3 py-3" color="#FFF" style="box-shadow:none" height="680px" align="center">
            <div id="box2" class="pa-5 py-10 col-10 col-sm-10 col-md-8 col-lg-6">
              <v-row style="margin-top:3%; margin-left:3%">
                <div class="mx-5 firstBar" ></div>
                <h4 class="pr-8" style="font-size:26px">申請帳號</h4>
              </v-row>
              <v-row justify="center" class="mt-6 mb-4">
                <v-btn class="mx-2 my-1 border" outlined style="background:#FFF; height:40px; width:200px; border: 1px solid #81C0E2" @click="idenity = 'general'">
                  <input type="radio" class="ma-0 pa-0 pt-3" value="general" color="#81C0E2" v-model="idenity">
                  <span class="pl-1" style="font-weight:600">一般帳號</span>
                </v-btn>
                <v-btn class="mx-2 my-1 border" outlined style="background:#FFF; height:40px; width:200px; border: 1px solid #81C0E2" @click="idenity = 'teacher'">
                  <input type="radio" class="ma-0 pa-0 pt-3" value="teacher" color="#81C0E2" v-model="idenity">
                  <span class="pl-1" style="font-weight:600">教師帳號</span>
                </v-btn>
              </v-row>
              <v-row class="mt-2" justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>國籍</div>
                </v-col>
                <v-col class="py-0 col-9 py-0 pt-1 pl-5">
                  <v-radio-group class="ma-0 pa-0" dense v-model="datasets.citizenShip">
                    <v-row>
                      <v-radio v-for="(data,index) in citizenShipList" :key="index" :value = "(index+1).toString()" class="pr-2" color="#215DA7">
                        <template v-slot:label>
                          <span class="pt14" style="color:#000000">{{data.title}}</span>
                        </template>
                      </v-radio>
                    </v-row>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row class="mt-2" justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>帳號</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-text-field class="border pt14" dense background-color="white" outlined placeholder="請輸入身分證或護照號碼" maxlength="50" v-model="datasets.idCard"
                  @keyup="datasets.idCard = datasets.idCard.replace(/[\u4e00-\u9fa5]/ig,'') && datasets.idCard.toUpperCase(), datasets.idCard = $Global.toCDB(datasets.idCard)"></v-text-field>
                </v-col>
                <v-col class="pa-0 pt-1 text-left col-1">
                  <v-icon v-if="isIdCardOk" color="#81E285" size="30">mdi-check-all</v-icon>
                  <v-icon v-else color="#E28181" size="30">mdi-close</v-icon>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-3 pt14"><span class="start">*</span>密碼</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y left min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field dense outlined background-color="white" readonly class="text_field datePicker" placeholder="請選擇出生年月日"
                      maxlength="10" v-model="datasets.birthday" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                      </v-text-field>
                    </template>
                    <v-date-picker ref="picker" v-model="datasets.birthday" no-title scrollable
                      :max="new Date().toISOString().substr(0, 10)" :picker-date="pickerDate" @change="$refs.menu.save(datasets.birthday)"
                    ></v-date-picker>
                  </v-menu>
                  <!-- <v-menu ref="menu" v-model="menu" transition="scale-transition" offset-y left min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field dense outlined background-color="white" readonly class="text_field" placeholder="請選擇"
                        v-model="datasets.birthday" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="datasets.birthday" no-title scrollable :allowed-dates="allowedDates"></v-date-picker>
                  </v-menu> -->
                </v-col>
                <v-col class="pa-0 pt-1 text-left col-1">
                  <!-- <v-icon color="#81E285" size="30">mdi-check-all</v-icon> -->
                  <!-- <v-icon color="#E28181" size="30">mdi-close</v-icon> -->
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>再次輸入密碼</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-text-field class="border pt14" dense background-color="white" outlined placeholder="請輸入出生年月日" maxlength="10" v-model="birthdayAgain"
                  @keyup="birthdayAgain = $Global.toCDB(birthdayAgain)"></v-text-field>
                </v-col>
                <v-col class="pa-0 pt-1 text-left col-1">
                  <v-icon v-if="isBirthdayAgainMatch" color="#81E285" size="30">mdi-check-all</v-icon>
                  <v-icon v-if="!isBirthdayAgainMatch" color="#E28181" size="30">mdi-close</v-icon>
                </v-col>
              </v-row>
              <v-row justify="center">
                <div class="pa-2 col-2">
                  <v-checkbox class="checkboxRight ma-0 pa-0" color="#81C0E2" v-model="isReadAgreement"></v-checkbox>
                </div>
                <div class="pt-3 col-9 text-left" style="font-size:10pt">
                  <span>我已同意並仔細閱讀</span>
                  <a @click="registerConsent = 2"><span style="text-decoration:underline; color:#81C0E2">CERPS學會帳號申請同意書</span></a>
                  <span>所記載之內容。</span>
                </div>
              </v-row>
              <v-btn class="my-1 loginBtn col-10 col-sm-10 col-md-8 col-lg-6" outlined style="height:40px" @click="checkStatusInStep1()">
                <span style="color:#FFFFFF">下一步</span>
              </v-btn>
              <v-row justify="center">
                <v-col class="px-1 text-left col-10 col-sm-10 col-md-8 col-lg-6">
                <span style="font-size:10pt">*提醒您，身分證字號為後續登入帳號唯一值，西元出生年月日為密碼。避免後續無法登入，請勿填寫假資訊，謝謝您。</span>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-stepper-content>

        <!-- 帳號資訊-一般帳號 -->
        <v-stepper-content step="2">
          <v-card v-if="idenity == 'general'" class="my-3 py-3" color="#FFF" style="box-shadow:none" height="680px" align="center">
            <div id="box2" class="pa-5 py-10 col-10 col-sm-10 col-md-8 col-lg-6">
              <v-row style="margin-top:3%; margin-left:3%">
                <div class="mx-5 firstBar"></div>
                <h4 class="pr-8" style="font-size:26px">一般帳號</h4>
              </v-row>
              <v-row class="mt-6" justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>中文姓名</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-text-field class="border pt14" dense background-color="white" outlined placeholder="請輸入姓名" maxlength="50" v-model="datasets.name"
                  @keyup="datasets.name = $Global.toCDB(datasets.name)"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-2" justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>電子信箱</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <email-auto-complete ref="EmailAutoComplete" :onCompletion='(val) => datasets.email = val' :domains='mailCandidateList'>
                    <input class="emailAutoComplete" type="text" placeholder="請輸入電子信箱" maxlength="50" v-model='datasets.email'
                    @keyup="[$refs.EmailAutoComplete.check($event), datasets.email= datasets.email.replace(/[\u4e00-\u9fa5]/ig,''), datasets.email = $Global.toCDB(datasets.email)]" />
                  </email-auto-complete>
                </v-col>
              </v-row>
              <v-row class="mt-2" justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>行動電話</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-text-field class="border pt14" dense background-color="white" outlined placeholder="0900000000" maxlength="10" v-model="datasets.ctel"
                  @keyup="[datasets.ctel= datasets.ctel.replace(/\D/g,'')]"></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="pa-0 col-2 mt-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>通訊地址</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-row v-if="datasets.citizenShip == '1'">
                    <v-select class="text_field px-3 mt-2 col-12 col-lg-6" dense background-color="white" outlined placeholder="請選擇縣市" :items="countryList" item-text="country" item-value="country" v-model="datasets.country"></v-select>
                    <v-select class="text_field px-3 mt-2 col-12 col-lg-6" dense background-color="white" outlined placeholder="請選擇行政區" :items="areaList" item-text="area" item-value="area" v-model="datasets.area"></v-select>
                  </v-row>
                  <v-row>
                    <v-text-field class="border pt14 px-3 mt-2" dense background-color="white" outlined placeholder="請輸入詳細地址" maxlength="200" v-model="datasets.address"
                    @keyup="datasets.address = $Global.toCDB(datasets.address)"></v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-btn class="ma-2 loginBack col-9 col-sm-4 col-md-4 col-lg-3" style="height:40px" outlined @click="e1 = 1">
                  <span style="color:#81c0e2">回上頁</span>
                </v-btn>
                <v-btn class="ma-2 loginBtn col-9 col-sm-4 col-md-4 col-lg-3" style="height:40px" outlined @click="newGeneralset()">
                  <span style="color:#FFFFFF">送出資料</span>
                </v-btn>
              </v-row>
            </div>
          </v-card>

          <!-- 帳號資訊-教師帳號 -->
          <v-card v-if="idenity == 'teacher'" class="my-3" color="#FFF" style="box-shadow:none" height="720px" align="center">
            <div id="box2" class="pa-5 py-10 col-10 col-sm-10 col-md-8 col-lg-6">
              <v-row style="margin-top:3%; margin-left:3%">
                <div class="mx-5 firstBar"></div>
                <h4 class="pr-8" style="font-size:26px">教師帳號</h4>
              </v-row>
              <v-row class="mt-6" justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>中文姓名</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-text-field class="border pt14" dense background-color="white" outlined placeholder="請輸入姓名" maxlength="50" v-model="datasets.name"
                  @keyup="datasets.name = $Global.toCDB(datasets.name)"></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>電子信箱</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <email-auto-complete ref="EmailAutoComplete" :onCompletion='(val) => datasets.email = val' :domains='mailCandidateList'>
                    <input class="emailAutoComplete" type="text" placeholder="請輸入電子信箱" maxlength="50" v-model='datasets.email'
                    @keyup="[$refs.EmailAutoComplete.check($event), datasets.email= datasets.email.replace(/[\u4e00-\u9fa5]/ig,''), datasets.email = $Global.toCDB(datasets.email)]" />
                  </email-auto-complete>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>行動電話</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-text-field class="border pt14" dense background-color="white" outlined placeholder="0900000000" maxlength="10" v-model="datasets.ctel"
                  @keyup="[datasets.ctel= datasets.ctel.replace(/\D/g,'')]"></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>通訊地址</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-row v-if="datasets.citizenShip == '1'">
                    <v-select class="text_field px-3 col-12 col-lg-6" dense background-color="white" outlined placeholder="請選擇縣市" :items="countryList" item-text="country" item-value="country" style="width:48%" v-model="datasets.country"></v-select>
                    <v-select class="text_field px-3 col-12 col-lg-6" dense background-color="white" outlined placeholder="請選擇行政區" :items="areaList" item-text="area" item-value="area" style="width:48%" v-model="datasets.area"></v-select>
                  </v-row>
                  <v-row>
                    <v-text-field class="border pt14 px-3" dense background-color="white" outlined placeholder="請輸入詳細地址" maxlength="200" v-model="datasets.address"
                    @keyup="datasets.address = $Global.toCDB(datasets.address)"></v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>學校類別</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-row class="px-3">
                    <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇學校類別" :items="collegeCategoryList" item-text="title" item-value="valuev" v-model="datasets.collegeCategory"></v-select>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>學校/單位</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-row class="px-3">
                    <v-autocomplete v-if="datasets.collegeCategory!='4'" class="border pt14 autocomplete" placeholder="請選擇學校/單位" 
                    :items="schoolList" item-text="name" item-value="name" v-model="datasets.company"></v-autocomplete>
                    <v-text-field v-if="datasets.collegeCategory=='4'" class="text_field" dense background-color="white" outlined placeholder="請輸入單位名稱" v-model="datasets.company"></v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>系所/部門</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-row class="px-3">
                    <v-text-field class="border pt14" dense background-color="white" outlined placeholder="請輸入系所/部門" maxlength="50" v-model="datasets.department"
                    @keyup="datasets.department = $Global.toCDB(datasets.department)"></v-text-field>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="pa-0 col-2">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>職稱</div>
                </v-col>
                <v-col class="py-0 col-8">
                  <v-text-field class="border pt14" dense background-color="white" outlined placeholder="請輸入職稱" maxlength="50" v-model="datasets.jobtitle"
                  @keyup="datasets.jobtitle = $Global.toCDB(datasets.jobtitle)"></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-btn class="ma-2 loginBack col-9 col-sm-4 col-md-4 col-lg-3" style="height:40px" outlined @click="e1 = 1">
                  <span style="color:#81c0e2">回上頁</span>
                </v-btn>
                <v-btn class="ma-2 loginBtn col-9 col-sm-4 col-md-4 col-lg-3" style="height:40px" outlined @click="newTeacherset()">
                  <span style="color:#FFFFFF">送出資料</span>
                </v-btn>
               </v-row>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card class="my-3 py-3" color="#FFF" style="box-shadow:none" height="680px" align="center">
            <div id="box2" class="pa-5 py-10 col-10 col-sm-10 col-md-8 col-lg-6">
              <v-row style="margin-top:3%; margin-left:3%">
                <div class="mx-5 firstBar" ></div>
                <h4 style="font-size:26px">{{(idenity == 'general') ? '一般帳號' : '教師帳號'}}</h4>
              </v-row>
              <div v-if="idenity == 'general'" class="ma-0 pa-0">
                <v-row class="my-4 col-11" justify="center">
                  <span class="my-2 mt14" style="font-weight:600">您的帳號身份已開通，註冊成功的資訊已寄至電子信箱，登入系統就可以報名考試囉~</span>
                </v-row>
                <v-row justify="center">
                  <v-img :src="images.register_st" contain height="280" alt="一般帳號已開通圖示"></v-img>
                </v-row>
              </div>
              <div v-if="idenity == 'teacher'" class="ma-0 pa-0">
                <div class="my-4 col-11" justify="center">
                  <h4 class="my-1 mt14" style="font-weight:600">註冊成功，請您等待學會人員審核申請資格 !</h4>
                  <h4 class="mt14" style="font-weight:600">審核通過，系統將寄出註冊成功資訊至您的信箱 !</h4>
                </div>
                <v-row class="pt-4 pb-2 mx-2" justify="center">
                  <v-img :src="images.register_te" contain height="200" alt="教師帳號已開通圖示"></v-img>
                </v-row>
              </div>
              <v-btn class="my-5 col-10 col-sm-9 col-md-8 col-lg-6" outlined style="height:40px; background:#81c0e2; border-radius:8px; border:none" @click="redirectPath('/login')">
                <span style="color:#FFFFFF">登入系統</span>
              </v-btn>
            </div>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <div v-if="registerConsent === 2" :style="viewStyle2">
      <v-row class="mr-0" style="margin-top:20px; margin-left:12.5%">
        <div class="mx-5 firstBar"></div>
        <h4 style="font-size:26px">申請同意書</h4>
      </v-row>
      <v-row style="margin: 20px 0px" justify="center">    
        <textarea class="pt14 pa-10 col-10 col-sm-10 col-lg-9" rows="22" outlined required dense readonly
        style="width:100%; overflow-y:scroll; border: 2px solid #52575a; border-radius: 26px" v-model="examWatch.examWatch"></textarea>
      </v-row>
    </div>
    <ShowMsg ref="ShowMsg" />
  </div>
</template>

<script>
import CryptoJS from "crypto-js"
import EmailAutoComplete from "vue-email-autocomplete";
import "vue-email-autocomplete/dist/vue-email-autocomplete.css";
import ShowMsg from '@/dialogs/ShowMsg'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';

export default {
  name: 'LoginRegister',
  components: {EmailAutoComplete,ShowMsg,Loading},
  mounted(){
    this.getExamWatch()
    this.$Global.getMailCandidateList().then(res=>{ this.mailCandidateList = res })
    this.$Global.getCitizenShipList().then(res=>{ this.citizenShipList = res })
    this.$Global.getCollegeCategoryList().then(res=>{ this.collegeCategoryList = res })
    this.$Global.getCountryList().then(res=>{ this.countryList = res })
  },
  data:()=>({
    datasets: {citizenShip:'1', idCard:'', country:'', area:''},
    viewStyle1:{},
    viewStyle2:{},
    examWatch:'',
    registerConsent: 1, //1-註冊步驟 2-免費帳號申請同意書
    menu: false,
    pickerDate:(new Date().getFullYear()-20) + '-1-1',
    birthdayAgain:'',
    citizenShipList: [],
    countryList: [],
    collegeCategoryList: [],
    schoolList: [],
    areaList: [],
    e1: 1,
    isLoading: false,
    remeberMe:false,
    isIdCardOk:false,
    idCardInfo: [],
    isReadAgreement:false,
    images:{
      new_logo: require('@/assets/image/erp_logo.png'),
      register_te: require('@/assets/image/register_te.png'),
      register_st: require('@/assets/image/register_st.png'),
    },
    idenity:'general',
    mailCandidateList: [],
    requiredFieldGeneral:['name','email','ctel', 'address'],
    requiredFieldTeacher:['name','email','ctel', 'address','collegeCategory','company','department','jobtitle'],
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    menu (val) {
      val && setTimeout(() => (
        this.$refs.picker.activePicker = 'YEAR',
        this.pickerDate = null
      ))
    },
    "datasets.citizenShip":function(){
      this.datasets.idCard = ''
    },
    "datasets.collegeCategory":function(){
      this.$Global.getSchoolList(this.datasets.collegeCategory, true).then(res=>{ this.schoolList = res })
    },
    "datasets.country":function(){
      this.$Global.getAreaListByCountryList(this.datasets.country).then(res=>{ this.areaList = res })
    },
    "datasets.idCard":function(){
      if(this.datasets.citizenShip == '1'){
        if(this.datasets.idCard.length == 10){
          this.datasets.idCard = this.datasets.idCard.toUpperCase();
          this.$Global.checkIdCard(this.datasets.idCard).then(res=>{ this.isIdCardOk = res })
          this.$Global.getIdCardInfo(this.datasets.idCard).then(res=>{ this.idCardInfo = res })
          return
        }
        this.isIdCardOk = false
      }
      if(this.datasets.citizenShip == '2'){
        if(this.datasets.idCard.length > 5 && this.datasets.idCard.length <= 18){
          this.$Global.checkChinaIdCard(this.datasets.idCard).then(res=>{ this.isIdCardOk = res })
          this.$Global.getIdCardInfo(this.datasets.idCard).then(res=>{ this.idCardInfo = res })
          return
        }
        this.isIdCardOk = false
      }
      if(this.datasets.citizenShip == '3'){
        if(this.datasets.idCard.length > 5 && this.datasets.idCard.length <= 20){
          this.$Global.checkPassport(this.datasets.idCard).then(res=>{ this.isIdCardOk = res })
          this.$Global.getIdCardInfo(this.datasets.idCard).then(res=>{ this.idCardInfo = res })
          return
        }
        this.isIdCardOk = false
      }
    },
    "datasets.area":function(){
      this.datasets.zipCode = this.$Global.getZipCode(this.areaList, this.datasets.area, this.datasets.zipCode)
    },
  },
  computed:{
    isBirthdayAgainMatch () {
      return this.datasets.birthday == this.birthdayAgain
    },
  },
  methods:{
    calculateWindows(){
      this.viewStyle1 = {height: window.innerHeight-126 + 'px'}
      this.viewStyle2 = {height: window.innerHeight-146 + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    jsonConcat(o1, o2){
      for (var key in o2) {
        o1[key] = o2[key];
      }
      return o1;
    },
    getExamWatch(){
      var self = this
      var request = {
        method: 'POST',
        url: '/common/erpExamWatchByExamType/membershipConsent',
        params: {},
      }
      this.$http(request).then(function(response) {
        self.examWatch = response.data.data
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Lgr-7956')
      })
    },
    newGeneralset() {
      if(!this.$Global.checkForm(this.datasets,this.requiredFieldGeneral)){
        this.$refs.ShowMsg.open(1)
        return
      }
      if(!this.datasets.email.includes('@')){
        this.$refs.ShowMsg.open(5)
        return
      }
      if(this.datasets.citizenShip == '1'){
        if(this.datasets.country == '' || this.datasets.area == ''){
          this.$refs.ShowMsg.open(1)
          return
        }
      }
      this.datasets.idCard = this.datasets.idCard.trim()
      var allData = this.datasets
      allData = this.jsonConcat(allData,{'simulateExam' : 'false'})
      allData = this.jsonConcat(allData,{'memberType' : 'erpMember'})
      allData = this.jsonConcat(allData,{'memberStatus' : '0'})
      allData = this.jsonConcat(allData,{'memberId' : this.datasets.idCard})
      allData = this.jsonConcat(allData,{'passwd' : CryptoJS.MD5(this.datasets.birthday).toString()})
      allData = this.jsonConcat(allData,{'createId' : 'Apply'})
      this.isLoading = true
      var self = this
      var request = {
        method: 'POST',
        url: '/common/erpMember',
        data: this.Qs.stringify(allData)
      }
      this.$http(request).then(function(response) {
        if(response.data.msg == '成功!'){
          self.e1 = 3
        }else{
          self.$refs.ShowMsg.open(0,'系統提示','該帳號已存在，請聯繫系統管理人員')
        }
        self.isLoading = false
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Lgr-7957')
      })
    },
    newTeacherset() {
      if(!this.$Global.checkForm(this.datasets,this.requiredFieldTeacher)){
        this.$refs.ShowMsg.open(1)
        return
      }
      if(!this.datasets.email.includes('@')){
        this.$refs.ShowMsg.open(5)
        return
      }
      if(this.datasets.citizenShip == '1'){
        if(this.datasets.country == '' || this.datasets.area == ''){
          this.$refs.ShowMsg.open(1)
          return
        }
      }
      this.datasets.idCard = this.datasets.idCard.trim()
      var allData = this.datasets
      allData = this.jsonConcat(allData,{'memberStatus' : '1'})
      allData = this.jsonConcat(allData,{'memberType' : 'erpTeacher'})
      allData = this.jsonConcat(allData,{'memberId' : this.datasets.idCard})
      allData = this.jsonConcat(allData,{'passwd' : CryptoJS.MD5(this.datasets.birthday).toString()})
      allData = this.jsonConcat(allData,{'createId' : 'Apply'})
      this.isLoading = true
      var self = this
      var request = {
        method: 'POST',
        url: '/common/erpTeacher',
        data: this.Qs.stringify(allData)
      }
      this.$http(request).then(function(response) {
        // console.log(response)
        //dialog // TBD
        //this.$refs.ChangePassword.open()
        if(response.data.msg == '成功!'){
          self.e1 = 3
        }else{
          self.$refs.ShowMsg.open(0,'系統提示','該帳號已存在，請聯繫系統管理人員')
        }
        self.isLoading = false
      }).catch(()=>{
        //this.$refs.ChangePassword.open()
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Lgr-7958')
        self.isLoading = false
      })
    },
    checkStatusInStep1(){
      if(!this.isIdCardOk){
        this.$refs.ShowMsg.open(0,'帳號錯誤','請輸入您的身分證字號')
        return
      }
      if(this.idenity == 'general'){
        if(this.idCardInfo.erpTeacher){
          this.$refs.ShowMsg.open(0,'您已是教師帳號','該"身分證字號/護照號碼"已經是教師帳號，無法重複申請一般帳號。')
          return
        }
        if(this.idCardInfo.erpMember){
          this.$refs.ShowMsg.open(0,'您已是一般帳號','該"身分證字號/護照號碼"已經是一般帳號，無法重複申請，請點擊「忘記密碼」功能更新密碼。')
          return
        }
      }
      if(this.idenity == 'teacher'){
        if(this.idCardInfo.erpTeacher){
          this.$refs.ShowMsg.open(0,'您已是教師帳號','該"身分證字號/護照號碼"已經是教師帳號，無法重複申請。')
          return
        }
        if(this.idCardInfo.erpMember){
          this.$refs.ShowMsg.open(0,'您已是一般帳號','請聯絡學會專員進行教師帳號身分轉換。')
          return
        }
      }
      if(!this.isBirthdayAgainMatch){
        this.$refs.ShowMsg.open(0,'密碼不相符','請輸入您的生日當作預設密碼，且需包含-符號')
        return
      }
      if(!this.isReadAgreement){
        this.$refs.ShowMsg.open(0,'帳號同意書','請詳閱帳號同意書並勾選同意')
        return
      }
      this.e1 = 2
    }
  }
}
</script>

<style>
  ::-webkit-scrollbar {
    width: 7px;
  }
  ::-webkit-scrollbar-button {
    background: transparent;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.4);
    border: 1px solid slategrey;
  }
</style>